import { CService } from "./class.base.service";

class PaymentService extends CService {}

const paymentService = new PaymentService("payment-methods");
export default paymentService